module.exports = __webpack_public_path__ + "static/img/5.6d87ce5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/zh/5.png
// module id = 1fl/
// module chunks = 0